import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import DefaultButton from '../../../../../components/DefaultButton';
import messageManager from '../../../../../utilities/messageManager';
import loading from '../../../../../utilities/loading';
import Checkbox from '../../../../../components/checkbox/Checkbox';
import { fieldsDictionary } from '../../../../../utilities/flightDictionaries';
import { modalInstance } from './../../../../admin/Admin';

const TableWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const Table = styled.table`
    width: 100%;
    max-width: 320px;
    min-width: 200px;
    padding: 10px 0 10px 0;
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        >font {
            color: #cf4444;
        };
        border-bottom: 2px solid #265a9c;
    };
    tr {
        font-size: 15px;
        :hover {
            background-color: #d8d8d8;
        };
        height: 30px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
        font-size: 15px;
    };
    div {
        display: flex;
        text-align: left;
        align-items: flex-start;
    };
`;

const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px 0 12px 0;
    >div {
        min-width: 60px;
    };
`;

class ProjectAttributes extends React.Component {
    constructor(props) {
        super();
        this.state = {
            customerName: props.chosenCustomer.name,
            customerId: props.chosenCustomer.id,
            buttonDisabled: false,
            projectAttributes: [],
        }
    }

    componentDidMount () {
        this.getProjectAttributes();
    }

    componentDidUpdate(prevProps, prevState) {
        const { chosenCustomer } = this.props;
        if (prevProps.chosenCustomer !== chosenCustomer) {
            this.getProjectAttributes();
        }
    }

    getProjectAttributes() {
        const { BASE_URL, axiosInstance, t, chosenCustomer } = this.props;
        var customerId = chosenCustomer.id;
        this.setState({ buttonDisabled: true });
        loading.start();
        axiosInstance.get(`${BASE_URL}customers/${customerId}/attributes`)
            .then((response) => {
                const { data } = response;
                //get description name for project attributes, which is used to translate names 
                data.forEach(attribute => {
                    attribute.header =  fieldsDictionary[attribute.name].header;
                });
                this.setState({ projectAttributes: data, buttonDisabled: false });
                loading.stop();
            })
            .catch((error) => {
                messageManager.show({
                    type: 'error',
                    text: t(error.response.data ? error.response.data : t('Error occured while loading project attributes')),
                });
                this.setState({ buttonDisabled: false })
                loading.stop();
            });
    }

    handleClick (e) {
        const id = e.currentTarget.dataset.value;
        var attributesCopy = [...this.state.projectAttributes];
        attributesCopy[id].enabled = !attributesCopy[id].enabled;    
        this.setState ({projectAttributes: attributesCopy})
    }

    getListAttributes() {
        const { projectAttributes } = this.state;
        const { t, chosenCustomer } = this.props;
        const listAttributes = projectAttributes.map((attribute, index) =>
            !fieldsDictionary[attribute.name].required
                ? <tr key={attribute.id}>
                    <td>
                        {t(attribute.header)}
                    </td>
                    <td>
                        <Checkbox
                            data-value={index}
                            checked={this.state.projectAttributes[index].enabled}
                            onClick={this.handleClick.bind(this)}
                        />
                    </td>
                </tr>
                : null
        );

        return <Table>
                <thead>
                    <tr>
                        <th>
                            {t('Project attributes for')}
                            <font> {chosenCustomer.name} </font>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {listAttributes}
                </tbody>
            </Table>
    }

    saveProjectAttributes() {
        const { BASE_URL, axiosInstance, t, chosenCustomer } = this.props;
        const { projectAttributes } = this.state;      

        const confirmCallback = () => {
            this.setState({ buttonDisabled: true });
            const customerId = chosenCustomer.id;
            const newProjectAttributes = projectAttributes.map((attribute) => ({
                "id": attribute.id,
                "enabled": attribute.enabled
            }));
            loading.start();
            axiosInstance.put(`${BASE_URL}customers/${customerId}/attributes`, newProjectAttributes)
                .then((response) => {
                    messageManager.show({
                        type: 'info',
                        text: t('The customer project attributes have been successfully changed'),
                    });
                    this.setState({ buttonDisabled: false });
                    loading.stop();
                })
                .catch((error) => {
                    messageManager.show({
                        type: 'error',
                        text: t('Error occured while saving project attributes'),
                    });
                    this.setState({ buttonDisabled: false });
                    loading.stop();
                });
        }
        const cancelCallback = () => { }

        const config = {
            title: t('Save'),
            content: <p>{t('Do you really want to change project attributes for')}<b>{chosenCustomer.name}</b>?</p>,
            confirmCallback: confirmCallback,
            cancelCallback: cancelCallback,
            confirmBtnVisible: true,
            cancelBtnVisible: true,
            confirmBtnText: t('Save'),
            closeOnConfirm: true,
            type: 'warning',
        }
        modalInstance.customize(config);
        modalInstance.show();
    }

    render() {
        const { t } = this.props;

        return (
            <React.Fragment>
                <TableWrapper>
                    {this.getListAttributes()}
                </TableWrapper>
                <ButtonWrapper>
                    <DefaultButton
                        onClick={this.saveProjectAttributes.bind(this)}
                        disabled={this.state.buttonDisabled}
                    >
                        {t('Save')}
                    </DefaultButton>
                </ButtonWrapper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ProjectAttributes));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/projectAttributesAdmin/ProjectAttributes.jsx